import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Query, DataManager, ODataV4Adaptor  } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import * as AppConst from '../../data/test.data';
import { ReportParaFilter } from '../../models/report/report-para-filter.model';
import { CustListString } from '../../models/report/cust-list-string.model';
import { DatePipe } from '@angular/common';
import { MultiSelectCust } from '../../models/report/multi-select-cust.model';
import { GridComponent, ToolbarItems, ExcelExportProperties  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { saveAs as importedSaveAs } from "file-saver";


@Component({
    selector: '',
    templateUrl: './report.quota.html',
    styleUrls: ['./report.quota.less']
})
export class ReportQuota implements OnInit {

    public userLogin: string = '';
    public lstPrnStr: string = '';
    public lstCustStr: string = '';
    public show: boolean = false;

    //Area: Array<any> = ['All', 'HCM', 'HN', 'SOU', 'NOR', 'MEK', 'CEN'];
    //Detail: Array<any> = ['All', 'Tender', 'Renewal', 'Tender supplement', 'Price Application', 'Apply tender result', 'Direct purchase tender'];
    //statusReport: Array<any> = ['All', 'Open', 'Waiting for principal approve', 'Principal approved', 'Waiting tender result', 'Win', 'Lost', 'Cancel'];

    statusReport: Array<any> = [];
    Area: Array<any> = [];
    Detail: Array<any> = [];
    dateFormat = "dd/MM/yyyy";
    public dateValueFrom: Date = new Date();
    public dateValueTo: Date = new Date();
    public statusReportSelected: string = '';
    public areaSelected: string = '';
    public detailSelected: string = '';
    public empListPRN: Array<any> = [];
    public empListCust: Array<any> = [];
    public strFromYear: string = '';
    public strToYear: string = '';
    public strFromMonth: string = '';
    public strToMonth: string = '';
    //public dataPRN: string[] = ['All', 'A14', 'A05', 'A09', 'A12', 'A15', 'A17', 'A18', 'A19', 'A20', 'B01', 'B14', 'B15', 'B16', 'B17', 'B04', 'B06', 'B07', 'D01', 'E04', 'F02', 'F03', 'G03', 'G06', 'G10', 'H02', 'I01', 'J04', 'K01', 'L01', 'M03', 'M04', 'M18', 'M07', 'M19', 'M09', 'N12', 'N13', 'N16', 'N17', 'N18', 'N21', 'N23', 'P04', 'P10', 'P12', 'P09', 'S13', 'S27', 'S28', 'S29', 'S30', 'S31', 'S32', 'S34', 'T02'];
    public dataPRN: string[] = [];
    reportParaFilter = new ReportParaFilter();
    public placeholder: string = 'Select Principal';
    public placeholderCust: string = 'Select Customer';
    public dataReport: DataManager;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid') public grid: GridComponent;

    //public fields: Object = { text: 'label', value: 'value' };
    //public sorting: string = 'Ascending';
    //public custMTS: Array<MultiSelectCust> = [];

    //public data: DataManager;
    //public custMTS2: Array<CustListString> = [];
    //public text: string = "Select Customer";
    //public box: string = 'box';
    //public fields2: Object = { text: 'CustomerName', value: 'CustomerCode' };
    //public query: Query;
    //public empListCust2: Array<any> = [];
    //public query: Query = new Query().from('VS_CustomerFilter').select(['CustomerCode', 'CustomerName','CustAddr3']);

    //public pageSettings: PageSettingsModel;

    //Autocomplete
    public dataAutocomplete: DataManager;
    public textAutocomplete: string = "Find a customer";
    public textCustSelected: string = "";

    //Autocomplete Item
    public dataAutocompleteItem: DataManager;
    public textAutocompleteItem: string = "Find a item";
    public textItemSelected: string = "";

    constructor(private http: HttpService, private helper: HelperService, private datePipe: DatePipe, private auth: AuthenService) {
        this.getCustMTS();
        //this.pageSettings = { pageSize: 50 };
    }

    ngOnInit(): void  {
        this.toolbarOptions = ['ExcelExport'];

    }

    toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
            const excelExportProperties: ExcelExportProperties = {
                fileName: 'Daily Tender Quota Status.xlsx'
            };
            this.grid.excelExport(excelExportProperties);
        }
    }


    getCustMTS(){
    //this.http.get('api/Report/GetCustMultiSelect', res => {
    //        this.custMTS = res;
    //        var allOption = new MultiSelectCust();
    //        allOption.label = "All";
    //        allOption.value = "All";
    //        this.custMTS.push(allOption);
    //    }, null);

        //this.http.get('api/Report/GetCustomer', res => {
        //    this.data = res;
        //}, null);

        //this.query = new Query().select(['CustomerCode', 'CustomerName', 'CustAddr3']).take(100);

        this.http.get('api/Report/GetCustomerCodeAndName', res => {
            this.dataAutocomplete = res;
        }, null);

        if (this.auth.isZPV) {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
                if (this.dataPRN) {
                    this.http.get('api/Report/GetItemCodeAndName', res => {
                        this.dataAutocompleteItem = res;
                    }, null);
                }
            }, null);
            this.dataPRN.push('All');
        }
        else {
            this.userLogin = this.auth.LoginUser;
            this.http.get('api/Report/GetPRN/' + this.userLogin, res => {
                this.dataPRN = res;
                if (this.dataPRN) {
                    this.http.get('api/Report/GetItemCodeAndNameByUserLogin/' + this.dataPRN.join(";"), res => {
                        this.dataAutocompleteItem = res;
                    }, null);
                }
            }, null);
        }

        this.http.get('api/Report/GetVS_Area/', res => {
            this.Area = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderStatus/', res => {
            this.statusReport = res;
        }, null);

        this.http.get('api/Report/Get_VS_TenderDetail/', res => {
            this.Detail = res;
        }, null);
    }

    onFilteringCust(event) {
        this.empListCust.push(event.value);
    }

    //onFilteringCust2(event) {
    //    this.empListCust2.push(event.value);
    //}

    onFiltering(event) {
        this.empListPRN.push(event.value);
    }

    changeStatusReport(ev) {
        this.statusReportSelected = ev.value;
    }
    changeAreaReport(ev) {
        this.areaSelected = ev.value;
    }

    changeDetialReport(ev) {
        this.detailSelected = ev.value;
    }

    convertDateToString() {
        if (!this.statusReportSelected || 0 === this.statusReportSelected.length) {
            this.statusReportSelected = 'All';
        }

        if (!this.areaSelected || 0 === this.areaSelected.length) {
            this.areaSelected = 'All';
        }

        if (!this.detailSelected || 0 === this.detailSelected.length) {
            this.detailSelected = 'All';
        }

        if (!this.empListPRN || 0 === this.empListPRN.length) {
            //this.lstPrnStr = 'All';
            //this.lstPrnStr = String(this.dataPRN[0]);
            if (this.auth.isZPV) {
                this.lstPrnStr = 'All';
            }
            else {
                this.lstPrnStr = String(this.dataPRN[0]);
            }
        }
        else {
            this.lstPrnStr = this.empListPRN.join(";");
        }

        debugger
        if (!this.textCustSelected || 0 === this.textCustSelected.length || /^\s*$/.test(this.textCustSelected)) {
            this.textCustSelected = "All";
        }
        else if (this.textCustSelected.includes(" = ")){
            this.textCustSelected = this.textCustSelected.split(" = ")[2];
        }

        if (!this.textItemSelected || 0 === this.textItemSelected.length || /^\s*$/.test(this.textItemSelected)) {
            this.textItemSelected = "All";
        }
        else if (this.textItemSelected.includes(" = ")) {
            this.textItemSelected = this.textItemSelected.split(" = ")[1];
        }
 
        //if (!this.empListCust2) {
        //    this.lstCustStr = 'All';
        //}
        //else {
        //    this.empListCust = this.empListCust2.map(t => t.CustomerCode);
        //    this.lstCustStr = this.empListCust.join(";");
        //}

        let fromDate = this.datePipe.transform(this.dateValueFrom, 'yyyyMMdd');
        let toDate = this.datePipe.transform(this.dateValueTo, 'yyyyMMdd');
        this.strFromYear = fromDate.substring(0, 4);
        this.strToYear = toDate.substring(0, 4);
        this.strFromMonth = fromDate.substring(4, 6);
        this.strToMonth = toDate.substring(4, 6);

        this.reportParaFilter.FromMonth = this.strFromMonth;
        this.reportParaFilter.FromYear = this.strFromYear;
        this.reportParaFilter.ToMonth = this.strToMonth;
        this.reportParaFilter.ToYear = this.strToYear;
        this.reportParaFilter.Status = this.statusReportSelected;
        this.reportParaFilter.Area = this.areaSelected;
        this.reportParaFilter.Detail = this.detailSelected;
        this.reportParaFilter.Principal = this.lstPrnStr;
        this.reportParaFilter.CustCode = this.textCustSelected;
        this.reportParaFilter.ItemCode = this.textItemSelected;
    }
    onExportClick() {
        var element = <HTMLInputElement>document.getElementById("btnExcel");
        element.disabled = true;
        this.convertDateToString();
        //this.dataReport = new DataManager({ url: `${this.http.baseUrl}api/Report/GetPageReportByQuota?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Principal=${this.reportParaFilter.Principal}&CustCode=${this.reportParaFilter.CustCode}&ItemCode=${this.reportParaFilter.ItemCode}`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });

        this.show = true;
        this.http.download(`api/Report/ExportVS_ReportByQuota?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Detail=${this.reportParaFilter.Detail}&Principal=${this.reportParaFilter.Principal}&CustCode=${this.reportParaFilter.CustCode}&ItemCode=${this.reportParaFilter.ItemCode}&fromDate=${this.datePipe.transform(this.dateValueFrom, 'yyyy-MM-dd')}&toDate=${this.datePipe.transform(this.dateValueTo, 'yyyy-MM-dd')}`, res => {
            importedSaveAs(res, "Tender Quota Status.xlsx");
            this.show = false;
            element.disabled = false;
        });
    }

    //onActionFailure(e: Error): void {
    //    this.helper.alert(e.message);
    //}

    onChangedCustomer(e) {
        if (e.item) {
            this.textCustSelected = e.itemData;
        } else {
            this.textCustSelected = "";
        };
    }

    onChangedItem(e) {
        if (e.item) {
            this.textItemSelected = e.itemData;
        } else {
            this.textItemSelected = "";
        };
    }

}
